import { Col, Row, Input } from 'reactstrap';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoggedUserType } from '../../../utils/Types';
import { loginSelector } from '../../../redux/slices/loginSlice';
import { FormUtils } from '../../../utils/FormUtils';
import { checkNullValue, formattedDate, formattedDateWithFormat,  getCurrentDateTime, getDepartmentData, getUpdateLobData, getIdByValue, decodeHtml, convertSeverityOptions } from '../../../utils/Util';
import { mapMasters } from '../../../utils/MastersMapping';
import LabelField from '../../../components/LabelField';
import TextInput from '../../../components/TextInput';
import TextAreaInput from '../../../components/TextAreaInput';
import SelectInput from '../../../components/SelectInput';
import ActivityLog from './ActivityLog';
import { getAllUsersByDepartment } from '../../../api/roleMasterApi';
import { toast } from 'react-toastify';
import { LINE_OF_BUSINESS, MIN_DATE_INTIMATION, REMARKS_HELPER_TEXT, ROLE_ID, STATUS, TYPE_OF_REQUEST_ID } from '../../../utils/Constant';
import { getDistrictsApi, getGrievanceDescriptionsApi, getLocationDataApi, getProductsByLobApi, productMastersApi } from '../../../api/grievancesApi';
import { handleLocationDataSlice } from '../../../redux/slices/grievancesSlice';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
const GrievanceDetails = ({
  data,
  register,
  watch,
  getValues,
  setValue,
  errors,
  setImage,
  grievance_id,
  createdDate,
  closureDate
}: any) => {

  const user: LoggedUserType = useSelector(loginSelector).user;
  const [isClosing, setIsClosing] = useState(false);
  const dispatch: any = useDispatch();
  const {
    storeGrievanceDetailsData,
    storeDepartmentData,
    storeComplaintModeData,
    storeComplaintSourceData,
    storeLOBData,
    storeRequesTypeData,
    storeLocationData,
    storeFinalDispositionData,
    storeStatusData,
    storeGrievanceDescriptionData,
    storeStateMasterData,
    storeDistrictMasterData,
    storeSeverityData
  } = useSelector((state: any) => state.grievances);
  const {
    storeUserListByDepartment
  } = useSelector((state: any) => state.roleMaster);

  const grievanceDetailsData = storeGrievanceDetailsData.data ?? []
  const locationData = storeLocationData ?? {}
  const departmentData = getDepartmentData(
    storeDepartmentData.data ?? []
  );

  const complaintSourceData = FormUtils.convertDataList(
    storeComplaintSourceData.data ?? []
  );

  const complaintModeData = FormUtils.convertDataList(
    storeComplaintModeData.data ?? []
  );

  const lobList = getUpdateLobData(FormUtils.convertDataList(
    storeLOBData?.data ?? []
  ))

  const requestList = FormUtils.convertDataList(
    storeRequesTypeData.data ?? []
  )

  const resolutionDispositionData = FormUtils.convertDataList(
    storeFinalDispositionData.data ?? []
  );

  const statusData = FormUtils.convertDataList(
    storeStatusData?.data ?? []
  );

  const complaintDescriptionList = FormUtils.convertDataList(
    storeGrievanceDescriptionData?.data ?? []
  );

  const stateData = FormUtils.convertDataList(
    storeStateMasterData.data ?? []
  );
  const districtData = FormUtils.convertDataList(
    storeDistrictMasterData.data ?? []
  );
  const severityOptions = convertSeverityOptions(
    storeSeverityData.data ?? []
  );
  const isGrievance = mapMasters(watch('request'), requestList) === TYPE_OF_REQUEST_ID.GRIEVANCE;
  const isResolved = mapMasters(watch('status'), statusData) === STATUS.RESOLVE;
  const isSeverityAlreadySet =
    checkNullValue(grievanceDetailsData?.severityId) !== 'N/A';
  const severity = watch('severity');
  const department = watch('department');
  const spoc = watch('spoc');
  const intimationDate = watch('intimationDate');
  const lob = watch('lob');
  const request = watch('request');
  const doesNotPertain = watch('doesNotPertain');
  const mode = watch('mode');
  const resolutionDisposition = watch('resolutionDisposition');
  const source = watch('source');
  const status = watch('status');
  const complaintDescription = watch('complaintDescription');
  const [statusList, setStatusList] = useState<any>([]);
  const [departmentList, setDepartmentList] = useState<any>([{ value: 1, label: 'GRO' }]);
  const [spocList, setSpocList] = useState<any>([]);
  const [activityLog, setActivityLog] = useState([])
  const [modeOfComplaintData, setModeOfComplaintData] = useState(complaintModeData);
  const hideAsterisk = ['Duplicate', 'Rejected'].includes(getValues('resolutionDisposition'));
  const isAmountAlreadySet = !!checkNullValue(data?.claimReceivedAmount) && checkNullValue(data?.claimReceivedAmount) !== 'N/A';
  const pincode = watch('pincode');
  const state = watch('state')
  const isNonEditableLocation = checkNullValue(data?.grievanceAddress?.addressLine1) !== 'N/A' || checkNullValue(data?.grievanceAddress?.pincode) !== 'N/A';
  const [pincodePopulated, setPincodePopulated] = useState<boolean>(false);
  const [showNote, setShowNote] = useState(false);

  useEffect(() => {
    let filteredDepartmentData = departmentData.filter((department: any) =>
      (department.label !== 'Super Admin' && department.label !== 'PMFBY' && checkNullValue(department?.lobId) !== 'N/A') || (department?.label == 'GRO')
    );
    filteredDepartmentData = filteredDepartmentData.filter((department: any) => {
      if (mapMasters(lob, lobList) === LINE_OF_BUSINESS.TO_BE_ASSIGNED) {
        return true;
      } else if ((department?.label == 'GRO')) {
        return department;
      } else {
        return department?.lobId === mapMasters(lob, lobList);
      }
    });

    if (user.roleId === ROLE_ID.GRO || user.roleId === ROLE_ID.AGENT || user.roleId === ROLE_ID.SUPER_ADMIN) {
      setDepartmentList(filteredDepartmentData);
    } else {
      filteredDepartmentData = filteredDepartmentData?.filter((department: any) => {
        return user?.roleName?.includes(department?.label) || department?.label === 'GRO'
      })
      setDepartmentList(filteredDepartmentData);
    }
  }, [user, departmentData, lob]);

  useEffect(() => {
    let statusOptions = statusData ?? [];
    switch (grievanceDetailsData?.grievanceStatus?.statusId) {
      case 1: setStatusList(statusOptions?.filter((status: any) => { return (status.value == STATUS.NEW || status.value == STATUS.IN_PROGRESS) })); break;
      case 2: setStatusList(statusOptions?.filter((status: any) => { return (status.value == STATUS.IN_PROGRESS || status.value == STATUS.RESOLVE) })); break;
      case 3:
        let options: any = statusOptions?.filter((status: any) => { return (status.value == STATUS.RESOLVE) });
        if (user?.permissions?.includes('reopen-close-grievance')) {
          options.push(statusOptions?.find((status: any) => { return (status.value == STATUS.REOPEN) }));
          if (calculateTAT() > 56) {
            options.push(statusOptions?.find((status: any) => { return (status.value == STATUS.CLOSE) }));
          }
        }
        setStatusList(options);
        break;
      case 4: setStatusList(statusOptions?.filter((status: any) => { return (status.value == STATUS.RESOLVE) })); break;
      case 5: setStatusList([]); break;
      default: setStatusList(statusOptions?.filter((status: any) => { return (status.value == STATUS.NEW || status.value == STATUS.IN_PROGRESS) })); break;
    }

  }, [grievanceDetailsData?.grievanceStatus?.statusId]);

  useEffect(() => {
    setValue('status', status)
  }, [statusList])


  useEffect(() => {
    if (source === 'InDirect') {
      if (grievanceDetailsData?.grievanceModeBean?.grievanceModeId == 20) {
        setValue('mode', mapMasters(grievanceDetailsData?.grievanceModeBean?.grievanceModeId, modeOfComplaintData));
      }
      let modeData = complaintModeData.filter((each: any) => {
        if (each.value < 5 || each.value == 16 || each.value == 18 || each.value == 17 || each.value == 22 || each.value === 20) { return each }
      })
      setModeOfComplaintData(modeData)
    }
    else if (source === 'Direct') {
      if (grievanceDetailsData?.grievanceModeBean?.grievanceModeId == 20) {
        setValue('mode', mapMasters(grievanceDetailsData?.grievanceModeBean?.grievanceModeId, modeOfComplaintData));
      }
      let modeData = complaintModeData.filter((each: any) => {
        if ((each.value > 4 && each.value < 16) || each.value == 19 || each.value == 23 || each.value === 20) { return each }
      })
      setModeOfComplaintData(modeData)
    }
    else if (source === 'To Be Assigned') {
      let modeData = complaintModeData.filter((each: any) => {
        if (each.value === 20) { return each }
      })
      setModeOfComplaintData(modeData)
      setValue('mode', 'To Be Assigned')
    }
  }, [source])
  useEffect(() => {
    if (resolutionDisposition === 'Rejected' && data?.grievanceTypeBean?.grievanceTypeId == 14) {
      setValue('claimReceivedAmount', '0', { shouldValidate: true });
    }
    if (getValues('resolutionDisposition') === 'Duplicate' || getValues('resolutionDisposition') === 'Partially Accepted' || getValues('resolutionDisposition') === 'Fully Accepted') {
      setValue('claimReceivedAmount', '', { shouldValidate: true });
    }
  }, [resolutionDisposition, setValue]);
  useEffect(() => {
    const dataLog = grievanceDetailsData?.grievanceActivities?.map((each: any, i: number) => {
      let creadted_date = '';
      let integrationSourceId = grievanceDetailsData?.grievanceIntegrationSource?.grievanceIntegrationSourceId;
      if (checkNullValue(each?.createdAt) != 'N/A') {
        creadted_date = each?.createdAt
      }
      else if (integrationSourceId > 1 && i == 0 && checkNullValue(each.remark) == 'N/A') {
        return;
      }
      return {
        id: i + 1,
        log: checkNullValue(each.remark),
        date: checkNullValue(creadted_date),
        name: checkNullValue(each.createdBy)
      }
    })
    setActivityLog(dataLog)
  }, [])


  const onChangeInput = (label: any, value: any,) => {
    setValue(label, value, { shouldValidate: true })
    if (label) {
      setShowNote(Boolean(value));
    }
  }

  useEffect(() => {
    switch (mapMasters(status, statusData)) {
      case STATUS.CLOSE:
        setIsClosing(true);
        let policynumber = checkNullValue(grievanceDetailsData?.policyNumber);
        let claimid = checkNullValue(grievanceDetailsData?.claimId);
        let department = checkNullValue(grievanceDetailsData?.grievanceDepartment?.department);
        let mode = checkNullValue(grievanceDetailsData?.grievanceModeBean?.grievanceMode);
        let source = checkNullValue(grievanceDetailsData?.grievanceSourceBean?.grievanceSource);
        let spoc = checkNullValue(grievanceDetailsData?.spoc);
        let date = formattedDateWithFormat(grievanceDetailsData?.createdAt, 'YYYY-MM-DDTHH:mm');
        setValue('policyId', policynumber);
        setValue('claimId', claimid);
        setValue('department', department);
        setValue('mode', mode);
        setValue('source', source);
        setValue('intimationDate', date);
        setValue('spoc', spoc);
        setValue('resolutionDisposition', resolutionDispositionData.find((each: any) => each.value === grievanceDetailsData?.finalDisposition)?.label);
        setValue('isSeniorCitizen', grievanceDetailsData?.isSeniorCitizen);
        setValue('doesNotPertain', grievanceDetailsData?.isDoesNotPertain);
        setValue('requestIRDAIForClosure', grievanceDetailsData?.requestIRDAIForClosure)
        setValue('complaintDescription', complaintDescriptionList.find((each: any) => each.value === grievanceDetailsData?.complaintDescriptionId)?.label);
        setValue('doesNotPertainRemarks', checkNullValue(grievanceDetailsData?.isdoesNotPertain_Remarks));
        setValue('claimReceivedAmount', grievanceDetailsData?.claimReceivedAmount)
        setValue('isFRRDocList', checkNullValue(grievanceDetailsData?.requestIRDAIForClosure));
        break;
      case STATUS.REOPEN:
        setValue('resolutionDisposition', resolutionDispositionData.find((each: any) => each.value === grievanceDetailsData?.finalDisposition)?.label);
        break;
      case STATUS.RESOLVE:
        setValue('doesNotPertain', false);
        setValue('doesNotPertainRemarks', '');

        break;
      case STATUS.IN_PROGRESS:
        setValue('resolutionDisposition', resolutionDispositionData.find((each: any) => each.value === grievanceDetailsData?.finalDisposition)?.label);
        break;
      default:
        setIsClosing(false);
        break;
    }
  }, [status])

  useEffect(() => {
    setSpocList([])
    if (department && mapMasters(department, departmentData) != 14) {
      if (department != mapMasters(grievanceDetailsData.grievanceDepartment.grievanceDepartmentId, departmentData)) {
        setValue('spoc', '')
      }
      dispatch(getAllUsersByDepartment(department));
    }
  }, [department])

  useEffect(() => {
    if (storeUserListByDepartment?.length > 0) {
      let list: any = [];
      storeUserListByDepartment.map((user: any, i: number) => {
        list.push({ value: i, label: `${user.firstName} ${user.lastName ? user.lastName : ''}` })
      })
      setSpocList(list);
    }
  }, [storeUserListByDepartment])

  useEffect(() => {
    setValue('department', departmentData.find((each: any) => each.value === grievanceDetailsData?.grievanceDepartment?.grievanceDepartmentId)?.label)
    setValue('mode', complaintModeData.find((each: any) => each.value === grievanceDetailsData?.grievanceModeBean?.grievanceModeId)?.label)
    setValue('source', complaintSourceData.find((each: any) => each.value === grievanceDetailsData?.grievanceSourceBean?.grievanceSourceId)?.label)
    setValue('status', statusData.find((each: any) => each.value === grievanceDetailsData?.grievanceStatus?.statusId)?.label)
    setValue('severity', severityOptions.find((each: any) => each.value === grievanceDetailsData?.severityId)?.label)
    setValue('policyId', checkNullValue(grievanceDetailsData?.policyNumber))
    setValue('claimId', checkNullValue(grievanceDetailsData?.claimId))
    setValue('spoc', checkNullValue(grievanceDetailsData?.spoc))
    let date = formattedDateWithFormat(grievanceDetailsData?.createdAt, 'YYYY-MM-DDTHH:mm');
    setValue('intimationDate', date)
    setValue('lob', checkNullValue(grievanceDetailsData?.grievanceLineOfBussiness?.lineOfBussiness))
    setValue('request', checkNullValue(grievanceDetailsData?.grievanceServiceRequest?.service))
    setValue('resolutionDisposition', resolutionDispositionData.find((each: any) => each.value === grievanceDetailsData?.finalDisposition)?.label)
    setValue('referenceNumber', grievanceDetailsData?.referenceId)
    setValue('grievanceType', grievanceDetailsData?.grievanceTypeBean?.grievanceTypeId)
    setValue('isSeniorCitizen', grievanceDetailsData?.isSeniorCitizen)
    setValue('doesNotPertain', grievanceDetailsData?.isDoesNotPertain)
    setValue('requestIRDAIForClosure', grievanceDetailsData?.requestIRDAIForClosure)
    setValue('isFRRDocList', grievanceDetailsData?.requestIRDAIForClosure)
    setValue('insurerResolutionLetterdate', grievanceDetailsData?.insurerResolutionLetterdate)
    setValue('dateOfHonoringService', grievanceDetailsData?.dateOfHonoringService)
    grievanceDetailsData?.isDoesNotPertain && setValue('doesNotPertainRemarks', checkNullValue(grievanceDetailsData?.isdoesNotPertain_Remarks));
    setValue('claimReceivedAmount', grievanceDetailsData?.claimReceivedAmount)
    setValue('pincode', grievanceDetailsData?.grievanceAddress?.pincode)
    setValue('state', grievanceDetailsData?.grievanceAddress?.addressLine2)
    setValue('city', grievanceDetailsData?.grievanceAddress?.addressLine1)
  }, [])

  useEffect(() => {
    if (complaintDescriptionList?.length > 0 && !complaintDescription) {
      setValue('complaintDescription', complaintDescriptionList.find((each: any) => each.value === grievanceDetailsData?.complaintDescriptionId)?.label)
    }
  }, [complaintDescriptionList])

  const handleTimeChange = (e: any) => {
    let inputValue = e.target.value?.split('T')[1];
    let currentDateValue = e.target.value?.split('T')[0];
    let currentTime = getCurrentDateTime()?.split('T')[1];
    let currentDateString = getCurrentDateTime()?.split('T')[0];

    if ((!currentDateValue || currentDateString === currentDateValue) && inputValue > currentTime) {
      e.target.value = '';
      toast.warn('You cannot select future time.');
    }
    else {
      setValue('intimationDate', e.target.value, { shouldValidate: true })
    }
  }

  const handleDateChange = (e: any, variable: string) => {
    setValue(variable, e.target.value, { shouldValidate: true })
  }

  const checkSpocPermission = () => {
    if (department === grievanceDetailsData?.grievanceDepartment?.department) {
      if (!(grievanceDetailsData?.spoc?.length > 0)) {
        // Check for assign permission
        return user?.permissions?.includes('assign-spoc');
      } else {
        // Check for reassign permission
        return user?.permissions?.includes('reassign-spoc');
      }
    } else {
      // Department is updated, check for assign permission
      return user?.permissions?.includes('assign-spoc');
    }

  }

  useEffect(() => {
    if (!pincodePopulated) {
      if (pincode?.length === 6) {
        dispatch(getLocationDataApi(pincode))
      }
      else {
        dispatch(handleLocationDataSlice({}))
      }
    }
    else {
      dispatch(handleLocationDataSlice({}))
      setPincodePopulated(false)
    }
  }, [pincode])

  useEffect(() => {
    // Auto-fill only when pincode is exactly 6 digits
    if (!pincodePopulated && Object.keys(locationData).length > 0 && typeof locationData !== "string") {
      setValue("state", locationData.data[0].state);
      setValue("city", locationData.data[0].district);
    }
  }, [locationData, pincode]);

  useEffect(() => {
    let stateId = getIdByValue(state, stateData)
    if (stateId > 0) {
      dispatch(getDistrictsApi(stateId))
    }
  }, [state])

  const calculateTAT = () => {
    const today = new Date();
    const intimationDate = new Date(grievanceDetailsData?.createdAt);
    const diffMs = today.getTime() - intimationDate.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  useEffect(() => {
    if (request === 'Grievance') {
      dispatch(getGrievanceDescriptionsApi(grievanceDetailsData?.grievanceTypeBean?.grievanceTypeId));
    }
  }, [request]);

  
  useEffect(() => {
    if(lob) {
      const lobId = mapMasters(lob, lobList)
      if (lobId === LINE_OF_BUSINESS.HEALTH) {
          dispatch(getProductsByLobApi(Number(lobId)));
      } else {
          dispatch(productMastersApi());
      }
    }
  }, [lob])

  useEffect(() => {
    if (resolutionDisposition === 'Rejected' && data?.grievanceTypeBean?.grievanceTypeId == 14) {
      setValue('claimReceivedAmount', '0', { shouldValidate: true });

    }
  }, [resolutionDisposition, setValue]);
  useEffect(() => {
    const addr = data?.grievanceAddress;

    // CASE 1 → addressLine1 & addressLine2 exist but pincode is NULL
    if (addr?.addressLine1 && addr?.addressLine2 && !addr?.pincode) {
      setValue("pincode", null);
      setValue("state", addr.addressLine2);
      setValue("city", addr.addressLine1);

      setValue("isPincodeLocked", true);
      dispatch(handleLocationDataSlice({}));
      setPincodePopulated(false);
      return;
    }

    // CASE 2 → everything null → allow pincode edit ONLY
    if (!addr?.addressLine1 && !addr?.addressLine2 && !addr?.pincode) {
      setValue("pincode", "");
      setValue("state", "");
      setValue("city", "");
      setValue("isPincodeLocked", false);
    }
  }, [data]);
  useEffect(() => {
    const val = getValues('remarks');
    if (!val || typeof val !== 'string') {
      setValue('remarks');
    }
  }, []);
  return (
    <>

      <Row style={{ borderBottom: '1px solid #D0DAE7', marginBottom: '3%', paddingBottom: '3%' }} >
        <Col xs={6} md={4}>
          <LabelField name='Grievance ID'></LabelField>
          <p style={{ color: '#00000080' }} className='grievance-details'>{grievance_id}</p>
        </Col>

        <Col xs={6} md={4}>
          <LabelField name='Policy ID'></LabelField>
          {data?.policyNumber ||
            (data?.grievanceStatus?.statusId === STATUS.CLOSE || isClosing || data?.freshworkReferenceId) ?
            <p className='grievance-details'>{checkNullValue(data?.policyNumber)}</p>
            :
            <TextInput
              changeFun={onChangeInput}
              valueName={'policyId'}
              register={register('policyId')}
              errors={errors}
              formValue={getValues('policyId')}
              className={'custom-input-text'}
            />
          }
        </Col>

        <Col xs={6} md={4}>
          <LabelField name='Application Number'></LabelField>
          <p className='grievance-details'>{checkNullValue(data?.applicationNumber)}</p>
        </Col>
        <Col xs={6} md={4}>
          <LabelField name='Claim ID'></LabelField>
          {(data?.grievanceStatus?.statusId === STATUS.CLOSE || isClosing || data?.freshworkReferenceId) ?
            (
              <p className='grievance-details'>{checkNullValue(data?.claimId)}</p>
            ) : (
              <TextInput
                changeFun={onChangeInput}
                valueName={'claimId'}
                register={register('claimId')}
                errors={errors}
                formValue={getValues('claimId')}
                className={'custom-input-text'}
              />
            )}
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name="Severity" />

          {mapMasters(status, statusData) === STATUS.NEW && !isSeverityAlreadySet ? (
            <SelectInput
              changeFun={onChangeInput}
              formValue={severity}
              valueName="severity"
              register={register('severity')}
              data={severityOptions}
              className="custom-input"
            />
          ) : (
            <p className="grievance-details">
              {
                checkNullValue(
                  severityOptions.find(
                    (opt: any) => opt.value === grievanceDetailsData?.severityId
                  )?.label
                )
              }
            </p>
          )}
        </Col>
      </Row>

      <Row>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Line of Business'></LabelField>
          {
            (data?.grievanceStatus?.statusId !== STATUS.CLOSE && !isClosing) &&
              (user?.permissions?.includes('update-line-of-business')) &&
              (data?.grievanceModeBean?.grievanceModeId === 2 || data?.grievanceModeBean?.grievanceModeId === 3 || data?.grievanceModeBean?.grievanceModeId === 4) && !data?.freshworkReferenceId
              ?
              <SelectInput
                changeFun={onChangeInput}
                formValue={lob}
                valueName={'lob'}
                register={register('lob')}
                data={lobList}
                className={'custom-input'}
              />
              :
              <p className='grievance-details'>{checkNullValue(grievanceDetailsData?.grievanceLineOfBussiness?.lineOfBussiness)}</p>
          }
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Type of Request'></LabelField>
          {
            (data?.grievanceStatus?.statusId !== STATUS.CLOSE && !isClosing) && (!data?.freshworkReferenceId || data?.freshworkToGrdsSync) && request !== 'Grievance'
              ?
              <SelectInput
                changeFun={onChangeInput}
                formValue={request}
                valueName={'request'}
                register={register('request')}
                data={requestList}
                className={'custom-input'}
              />
              :
              <p className='grievance-details'>{checkNullValue(request)}</p>
          }
        </Col>
        {request === 'Grievance' && (
          <Col xs={6} md={4} className="mb-3">
            <LabelField name='Complaint Description' required={request === 'Grievance'}></LabelField>
            <SelectInput
              changeFun={onChangeInput}
              formValue={complaintDescription}
              valueName={'complaintDescription'}
              register={register('complaintDescription', { required: request === 'Grievance' })}
              disabled={(data?.freshworkReferenceId && data?.freshworkToGrdsSync == false) || grievanceDetailsData?.complaintDescriptionId}
              data={complaintDescriptionList}
              className={'custom-input'}
              errors={errors}
              label={'Complaint Description'}
            />
          </Col>
        )}
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Grievance Intimation Date & Time'></LabelField>
          {
            (data?.grievanceStatus?.statusId !== STATUS.CLOSE && !isClosing) && (!data?.freshworkReferenceId || data?.freshworkToGrdsSync == true) &&
              (user?.permissions?.includes('update-grievance-intimation-date'))
              ?
              <Row>
                <Col xs={12} md={11}>
                  <Input
                    type="datetime-local"
                    max={getCurrentDateTime()}
                    min={`${MIN_DATE_INTIMATION}T00:00`}
                    {...register("intimationDate")}
                    onChange={handleTimeChange}
                    style={{ maxWidth: '95%', fontSize: '13px' }}
                    value={getValues('intimationDate')}
                  />
                </Col>
              </Row>
              :
              <p className='grievance-details'>{checkNullValue(createdDate)}</p>
          }
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='GRDS to BB Date' />
          <p className='grievance-details'>
            {
              checkNullValue(grievanceDetailsData?.grdsToBBDate ? formattedDateWithFormat(grievanceDetailsData?.grdsToBBDate, 'DD-MM-YYYY hh:mm A') : undefined)
            }
          </p>
        </Col>

        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Department'></LabelField>
          {
            (data?.grievanceStatus?.statusId !== STATUS.CLOSE && !isClosing) && (!data?.freshworkReferenceId || data?.freshworkToGrdsSync) &&
              (user?.permissions?.includes('update-department'))
              ?
              <SelectInput
                changeFun={onChangeInput}
                formValue={department}
                valueName={'department'}
                register={register('department')}
                data={departmentList}
                className={'custom-input'}
              />
              :
              <p className='grievance-details'>
                {data?.grievanceDepartment?.grievanceDepartmentId &&
                  checkNullValue(data?.grievanceDepartment?.department)
                }
              </p>
          }
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='SPOC'></LabelField>
          {checkSpocPermission() &&
            (data?.grievanceStatus?.statusId !== STATUS.CLOSE && !isClosing) && (!data?.freshworkReferenceId || data?.freshworkToGrdsSync) ?
            <>
              <SelectInput
                data={spocList}
                valueName={'spoc'}
                register={register('spoc')}
                changeFun={onChangeInput}
                formValue={spoc}
                className={'custom-input'}
                disabled={!department || mapMasters(department, departmentData) === 14}
              />
            </>
            :
            <>
              <p className='grievance-details'>{checkNullValue(data?.spoc)}</p>
            </>
          }
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Status'></LabelField>
          {(data?.grievanceStatus?.statusId !== STATUS.CLOSE) && (!data?.freshworkReferenceId || data?.freshworkToGrdsSync == true)
            ?
            <SelectInput
              data={statusList}
              formValue={status}
              valueName={'status'}
              register={register('status')}
              onChange={onChangeInput}
              className={'custom-input'}
            />
            :
            <p className='grievance-details'>{checkNullValue(data?.grievanceStatus?.status)}</p>
          }
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Name'></LabelField>
          <p className='grievance-details'>{checkNullValue(data?.grievanceRequester?.name)}</p>
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Mobile Number'></LabelField>
          <p className='grievance-details'>{checkNullValue(data?.grievanceRequester?.mobileNumber)}</p>
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Email ID'></LabelField>
          <p className='grievance-details'>{checkNullValue(data?.grievanceRequester?.email)}</p>
        </Col>
        <>
          <Col xs={6} md={4} className="mb-3 ">
            <LabelField name="Pincode" required={!isNonEditableLocation} />

            {isNonEditableLocation ? (
              <p className="grievance-details">{checkNullValue(data?.grievanceAddress?.pincode)}</p>
            ) : (
              <TextInput
                changeFun={onChangeInput}
                valueName="pincode"
                register={register('pincode', {
                  required: !isNonEditableLocation,
                  pattern: /^[0-9]{6}$/
                })}
                readOnly={getValues("pincode") === "N/A"}
                maxLength={6}
                errors={errors}
                errorMessage={{
                  required: '*Invalid Pincode',
                  pattern: "Please enter a valid 6-digit pincode"
                }}
                formValue={getValues('pincode')}
                required={!isNonEditableLocation}
                className={'custom-input-text'}
              />
            )}
          </Col>
          <Col xs={6} md={4} className="mb-3 ">
            <LabelField name="State" />

            {isNonEditableLocation ? (
              <p className="grievance-details">
                {checkNullValue(data?.grievanceAddress?.addressLine2)}
              </p>
            ) : (
              <TextInput
                changeFun={onChangeInput}
                valueName="state"
                register={register('state')}
                errors={errors}
                formValue={getValues('state')}
                readOnly={true}
                required={false}
                className={'custom-input-text'}
              />
            )}
          </Col>
          <Col xs={6} md={4} className="mb-3">
            <LabelField name="City / Town" />

            {isNonEditableLocation ? (
              <p className="grievance-details">
                {checkNullValue(data?.grievanceAddress?.addressLine1)}
              </p>
            ) : (
              <TextInput
                changeFun={onChangeInput}
                valueName="city"
                register={register('city')}
                errors={errors}
                formValue={getValues('city')}
                readOnly={true}
                required={false}
                className={'custom-input-text'}
              />
            )}
          </Col>
        </>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Reference Number'></LabelField>
          <p className='grievance-details'>{checkNullValue(data?.referenceId)}</p>
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Type of Grievance'></LabelField>
          <p className='grievance-details'>{data?.grievanceTypeBean?.grievanceTypeId && checkNullValue(data?.grievanceTypeBean?.grievanceType)}</p>
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Source of Complaint'></LabelField>
          {
            (data?.grievanceStatus?.statusId !== STATUS.CLOSE && !isClosing && !data?.freshworkReferenceId &&
              data?.grievanceSourceBean?.grievanceSourceId === 3
            ) ?
              <SelectInput
                changeFun={onChangeInput}
                formValue={source}
                valueName={'source'}
                register={register('source')}
                data={complaintSourceData}
                className={'custom-input'}
              />
              :
              <p className='grievance-details'>
                {data?.grievanceSourceBean?.grievanceSourceId &&
                  checkNullValue(data?.grievanceSourceBean?.grievanceSource)
                }
              </p>
          }
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Mode of Complaint'></LabelField>
          {
            (data?.grievanceStatus?.statusId !== STATUS.CLOSE && !isClosing && !data?.freshworkReferenceId &&
              data?.grievanceModeBean?.grievanceModeId === 20
            ) ?
              <SelectInput
                changeFun={onChangeInput}
                formValue={mode}
                valueName={'mode'}
                register={register('mode')}
                data={modeOfComplaintData}
                className={'custom-input'}
                disabled={(getValues('source') && getValues('source') !== 'To Be Assigned') ? false : true}
              />
              :
              <p className='grievance-details'>{
                data?.grievanceModeBean?.grievanceModeId &&
                checkNullValue(data?.grievanceModeBean?.grievanceMode)
              }
              </p>
          }
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Date of Closure'></LabelField>
          <p className='grievance-details'>{checkNullValue(closureDate)}</p>
        </Col>
        <Col xs={6} md={4} className="mb-3">
          <LabelField name='Freshworks Reference ID'></LabelField>
          <p className='grievance-details'>{checkNullValue(data?.freshworkReferenceId)}</p>
        </Col>
        {(data?.grievanceTypeBean?.grievanceTypeId == 14) &&
          ((mapMasters(status, statusData) === STATUS.RESOLVE || mapMasters(status, statusData) === STATUS.CLOSE)) &&
          <Col xs={6} md={4} className="mb-3">
            <LabelField name='Claim Received Amount' required={!isAmountAlreadySet}></LabelField>
            {(!isAmountAlreadySet && (data?.grievanceStatus?.statusId !== STATUS.CLOSE && !isClosing)) ? (<TextInput
              changeFun={onChangeInput}
              valueName={'claimReceivedAmount'}
              register={register('claimReceivedAmount', { required: true })}
              errors={errors}
              disabled={resolutionDisposition == 'Rejected' && data?.grievanceTypeBean?.grievanceTypeId == 14}
              errorMessage={{
                required: `Claim received amount is required`,
              }}
              formValue={getValues('claimReceivedAmount')}
              className={'custom-input-text'}
            />) :
              <p className='grievance-details'>
                {checkNullValue(data?.claimReceivedAmount)}
              </p>
            }
          </Col>
        }
        {(((mapMasters(status, statusData) === STATUS.RESOLVE || mapMasters(status, statusData) === STATUS.CLOSE) &&
          (data?.grievanceStatus?.statusId === STATUS.REOPEN && mapMasters(status, statusData) === STATUS.RESOLVE)) ||
          (data?.dateOfHonoringService))
          &&
          <>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name="Date of Honoring Service" required={!data?.dateOfHonoringService} />
              {!data?.dateOfHonoringService ? (
                <>
                  <Input
                    type="date"
                    {...register("dateOfHonoringService", { required: true })}
                    onChange={(e) => handleDateChange(e, "dateOfHonoringService")}
                    style={{ maxWidth: "95%", fontSize: "13px" }}
                    value={getValues("dateOfHonoringService")}
                  />
                  {errors?.dateOfHonoringService?.type === "required" && (
                    <p role="alert" className="error-msg">* This field is required</p>
                  )}
                </>
              ) : (
                <p className="grievance-details">
                  {formattedDate(data.dateOfHonoringService)}
                </p>
              )}
            </Col>
            <Col xs={6} md={4} className="mb-3">
              <LabelField name="Insurer Resolution Letter Date" required={!data?.insurerResolutionLetterdate} />
              {!data?.insurerResolutionLetterdate ? (
                <>
                  <Input
                    type="date"
                    {...register("insurerResolutionLetterdate", { required: true })}
                    onChange={(e) => handleDateChange(e, "insurerResolutionLetterdate")}
                    style={{ maxWidth: "95%", fontSize: "13px" }}
                    value={getValues("insurerResolutionLetterdate")}
                  />
                  {errors?.insurerResolutionLetterdate?.type === "required" && (
                    <p role="alert" className="error-msg">* This field is required</p>
                  )}
                </>
              ) : (
                <p className="grievance-details">
                  {formattedDate(data.insurerResolutionLetterdate)}
                </p>
              )}
            </Col>
            {(((mapMasters(status, statusData) === STATUS.RESOLVE || mapMasters(status, statusData) === STATUS.CLOSE) &&
              (data?.grievanceStatus?.statusId === STATUS.REOPEN && mapMasters(status, statusData) === STATUS.RESOLVE) &&
              ((data?.grievanceTypeBean?.grievanceTypeId == 14))) ||
              (data?.dateOfPayment)) &&
              <>
                <Col xs={6} md={4} className="mb-3">
                  <LabelField name='Date of Payment' required={!hideAsterisk}></LabelField>
                  {
                    (!data?.dateOfPayment) ?
                      <>
                        <Input
                          type="date"
                          {...register("dateOfPayment", { required: !hideAsterisk })}
                          onChange={(event) => handleDateChange(event, 'dateOfPayment')}
                          style={{ maxWidth: '95%', fontSize: '13px' }}
                          value={getValues('dateOfPayment')}
                        />
                        {errors && (errors['dateOfPayment']?.type === "required") &&
                          <p role="alert" className='error-msg'>* This field is required</p>
                        }
                      </>
                      :
                      <p className='grievance-details'>{
                        formattedDate(data?.dateOfPayment)
                      }
                      </p>
                  }
                </Col>
                <Col xs={6} md={4} className="mb-3">
                  <LabelField name='Payment Cheque Date' required={!hideAsterisk}></LabelField>
                  {
                    (!data?.paymentChequeDate) ?
                      <>
                        <Input
                          type="date"
                          {...register("paymentChequeDate", { required: !hideAsterisk })}
                          onChange={(event) => handleDateChange(event, 'paymentChequeDate')}
                          style={{ maxWidth: '95%', fontSize: '13px' }}
                          value={getValues('paymentChequeDate')}
                        />
                        {errors && (errors['paymentChequeDate']?.type === "required") &&
                          <p role="alert" className='error-msg'>* This field is required</p>
                        }
                      </>
                      :
                      <p className='grievance-details'>{
                        formattedDate(data?.paymentChequeDate)
                      }
                      </p>
                  }
                </Col>
                <Col xs={6} md={4} className="mb-3">
                  <LabelField name='Payment Cheque Number' required={!hideAsterisk}></LabelField>
                  {(!data?.paymentChequeNo) ?
                    (<TextInput
                      readOnly={data?.paymentChequeNo}
                      changeFun={onChangeInput}
                      valueName={'paymentChequeNo'}
                      register={register('paymentChequeNo', { required: !hideAsterisk })}
                      errors={errors}
                      errorMessage={{
                        required: `Payment cheque number is required`,
                      }}
                      formValue={getValues('paymentChequeNo')}
                      className={'custom-input-text'}
                    />) :
                    <p className='grievance-details'>
                      {checkNullValue(data?.paymentChequeNo)}
                    </p>
                  }
                </Col>
              </>
            }
          </>
        }
        {(mapMasters(status, statusData) === STATUS.RESOLVE || mapMasters(status, statusData) === STATUS.CLOSE) && user?.permissions?.includes('resolution-disposition') &&
          <Col xs={6} md={4} className="mb-3">
            <LabelField name='Resolution Disposition' required={mapMasters(status, statusData) === STATUS.RESOLVE}></LabelField>
            {
              (data?.grievanceStatus?.statusId !== STATUS.CLOSE && !isClosing
              ) ?
                <SelectInput
                  changeFun={onChangeInput}
                  formValue={resolutionDisposition}
                  valueName={'resolutionDisposition'}
                  register={register('resolutionDisposition', { required: mapMasters(status, statusData) === STATUS.RESOLVE })}
                  data={resolutionDispositionData}
                  className={'custom-input'}
                  errors={errors}
                  label={'Resolution Dispositon'}
                />
                :
                <p className='grievance-details'>{
                  checkNullValue(resolutionDispositionData.find((each: any) => each.value === grievanceDetailsData?.finalDisposition)?.label)
                }
                </p>
            }
          </Col>
        }
        {getValues('resolutionDisposition') === 'Duplicate' && (
          <Col xs={6} md={4} className="mb-3">
            <LabelField name='Original IRDAI Ticket Number' required={getValues('resolutionDisposition') === 'Duplicate'}></LabelField>
            {data?.originalIRDATokenNo ||
              (data?.grievanceStatus?.statusId === STATUS.CLOSE || isClosing) ?
              <p className='grievance-details'>{checkNullValue(data?.originalIRDATokenNo)}</p>
              :
              <TextInput
                changeFun={onChangeInput}
                valueName={'duplicateNotes'}
                register={register('duplicateNotes', {
                  required: getValues('resolutionDisposition') === 'Duplicate',
                  pattern: {
                    value: /^\d{2}-\d{2}-\d{6}$/,
                  },
                })}
                errorMessage={{
                  required: `IRDAI Ticket Number is required`,
                  pattern: `Enter in the format (00-00-000000)`
                }}
                errors={errors}
                maxLength={12}
                formValue={getValues('duplicateNotes')}
                readOnly={data?.grievanceStatus?.statusId === STATUS.CLOSE || isClosing}
                className={'custom-input-text'}
              />
            }
          </Col>
        )}
      </Row>
      <Row>
        {(((mapMasters(status, statusData) === STATUS.RESOLVE || mapMasters(status, statusData) === STATUS.CLOSE) &&
          (data?.grievanceStatus?.statusId === STATUS.REOPEN && mapMasters(status, statusData) === STATUS.RESOLVE)) ||
          (data?.dateOfHonoringService)) &&
          <>
            <Col xs={6} md={4} className="d-flex align-items-center gap-2">
              <LabelField name='Request IRDAI for Closure' required={true} className="w-auto"></LabelField>
              <Input
                type='checkbox'
                className="mb-2 border border-dark rounded"
                checked={getValues('requestIRDAIForClosure')}
                disabled={grievanceDetailsData?.requestIRDAIForClosure}
                register={register('requestIRDAIForClosure', { required: true })}
                onChange={(e) => {
                  onChangeInput('requestIRDAIForClosure', e.target.checked);
                }}
              />
            </Col>
            {errors && (errors['requestIRDAIForClosure']?.type === "required") &&
              <p role="alert" className='error-msg mb-1'>*Please check the Request IRDAI for Closure</p>
            }
            {
              <p role="alert" className='error-msg mt-1'>For reopened tickets, select Request IRDAI for Closure</p>}
          </>
        }
        <Col xs={6} md={4} className="mb-3 d-flex align-items-center gap-2">
          <LabelField name='Is Senior Citizen' className="w-auto"></LabelField>
          <Input
            type='checkbox'
            className="mb-2 border border-dark rounded"
            disabled={data?.freshworkReferenceId || data?.grievanceStatus?.statusId !== STATUS.NEW || grievanceDetailsData?.isSeniorCitizen}
            {...register('isSeniorCitizen')}
            checked={getValues('isSeniorCitizen')}
            onChange={(e) => onChangeInput('isSeniorCitizen', e.target.checked)}
          />
        </Col>
        <Col xs={6} md={4} className="mb-3 d-flex align-items-center gap-2">
          <LabelField name='Does Not Pertain' className="w-auto"></LabelField>
          <Input
            type='checkbox'
            className="mb-2 border border-dark rounded"
            disabled={(data?.freshworkReferenceId) || !(mapMasters(status, statusData) === STATUS.IN_PROGRESS || mapMasters(status, statusData) === STATUS.NEW) || grievanceDetailsData?.isDoesNotPertain}
            {...register('doesNotPertain')}
            checked={getValues('doesNotPertain')}
            onChange={(e) => {
              onChangeInput('doesNotPertain', e.target.checked);
              setValue('doesNotPertainRemarks', '');
            }}
          />
        </Col>
      </Row>
      <div className={`does-not-pertain-remarks-container ${getValues('doesNotPertain') ? 'show' : ''}`}>
        <Row>
          <Col xs={6} md={7} className="mb-3">
            <Row className="mb-3">
              <TextAreaInput
                label={'Does Not Pertain Remarks'}
                changeFun={onChangeInput}
                register={register('doesNotPertainRemarks', {
                  required: getValues('doesNotPertain') && !grievanceDetailsData?.isDoesNotPertain,
                  pattern: /^[^~!@#$^&;"'\[\]]{0,4000}$/,
                  maxLength: 4000
                })}
                readOnly={grievanceDetailsData?.isDoesNotPertain}
                placeholder={'Enter Does Not Pertain Remarks'}
                valueName={'doesNotPertainRemarks'}
                formValue={getValues('doesNotPertainRemarks')}
                errors={errors}
                errorMessage={{
                  maxLength: `Max 4000 characters are allowed`,
                  pattern: `Special characters which are not allowed are ~!@#$^&;"'[]`
                }}
                required={getValues('doesNotPertain') && !grievanceDetailsData?.isDoesNotPertain}
                maxrows={7}
              />
            </Row>
          </Col>
        </Row>
      </div>
      <Row>
        <Col xs={6} md={7} className="mb-3">
          <Row className="mb-3">
            <>
              <LabelField name="Description" />
              <div
                style={{
                  width: "90%",
                  marginLeft: "3%",
                  backgroundColor: "#ffffff",
                  // color: "#0a09094d",
                  fontSize: "12px",
                  padding: "12px",
                  border: "1px solid #D2D2E4",
                  borderRadius: "6px",
                  textAlign: 'left',
                  minHeight:
                    (user?.permissions?.includes('resolution-remarks') &&
                      (
                        user.roleId === ROLE_ID.GRO ||
                        user.roleId === ROLE_ID.AGENT ||
                        user.roleId === ROLE_ID.SUPER_ADMIN ||
                        user.roleName?.includes(
                          grievanceDetailsData?.grievanceDepartment?.department
                        )
                      ))
                      ? "44px"
                      : "154px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  whiteSpace: "pre-line",
                  opacity: 0.8
                }}
                onClick={(e: any) => { e.preventDefault(); }}
                onMouseEnter={(e: any) => { e.preventDefault(); }}
                dangerouslySetInnerHTML={{
                  __html: decodeHtml((checkNullValue(data?.description) ?? '').toString(), 'textarea')
                }}
              />
            </>
          </Row>
          {(user?.permissions?.includes('resolution-remarks') && (user.roleId === ROLE_ID.GRO || user.roleId === ROLE_ID.AGENT || user.roleId === ROLE_ID.SUPER_ADMIN || user.roleName?.includes(grievanceDetailsData?.grievanceDepartment?.department))) &&
            <Row>
              <Col xs={12} className="mb-2">
                <Row>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>

                    <span style={{ display: "flex", alignItems: "center" }}>
                      <LabelField required name="Remarks" />
                    </span>
                    {isGrievance && isResolved && (
                      <Tooltip
                        title={
                          <div style={{ maxWidth: 350 }}>
                            <div dangerouslySetInnerHTML={{ __html: REMARKS_HELPER_TEXT }} />
                          </div>
                        }
                        arrow
                        placement="right"
                      >
                        <InfoOutlinedIcon
                          className="mb-1"
                          style={{ fontSize: 16, cursor: "pointer", color: "#0078d4", }}
                        />
                      </Tooltip>
                    )}
                  </div>

                  <TextAreaInput
                    minrows={1}
                    changeFun={onChangeInput}
                    register={register('remarks', { required: true })}
                    readOnly={false}
                    placeholder={'Remarks'}
                    valueName={'remarks'}
                    formValue={getValues('remarks')}
                    errors={errors}

                    disabled={data?.freshworkReferenceId && !data?.freshworkToGrdsSync}
                  />
                  {isGrievance && isResolved && (
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        marginTop: "6px",
                        marginLeft: "4px"
                      }}
                    >
                      Note: Now the ombudsman details are appended automatically.
                    </p>
                  )}
                </Row>
              </Col>
            </Row>}
        </Col>
        {user?.permissions?.includes('activity-log') &&
          <Col xs={6} md={5} className="mb-3">
            <ActivityLog data={activityLog} />
            {/* 15 means website */}
            {((data?.grievanceModeBean?.grievanceModeId == 15) || (data?.freshworkSyncStatus)) &&
              (mapMasters(status, statusData) === STATUS.NEW) && !grievanceDetailsData?.freshworkReferenceId &&
              request !== 'Grievance' && (request !== 'To Be Assigned' && data?.grievanceModeBean?.grievanceModeId == 15) && !data?.referenceId &&
              (grievanceDetailsData?.grievanceAddress?.pincode || grievanceDetailsData?.grievanceAddress?.addressLine1) &&
              <>
                <img
                  src={require('../../../assets/img/download.jpeg')}
                  style={{ width: "20px", height: "20px", marginBottom: "18px" }}
                />
                <LabelField name='Move to Freshworks' className="w-auto mt-3 text-size"></LabelField>
                <Input
                  type='checkbox'
                  className="mb-2 border border-dark rounded  mt-3 left-checkbox"
                  {...register('moveToFreshWorks')}
                  checked={(getValues('moveToFreshWorks') || grievanceDetailsData?.freshworkSyncStatus)}
                  disabled={grievanceDetailsData?.freshworkSyncStatus}
                  onChange={(e) => {
                    onChangeInput('moveToFreshWorks', e.target.checked);
                  }} />
                {showNote && (
                  <p className="text-danger" style={{ fontSize: "12px" }}>Note: Moving this grievance to Freshworks will make the ticket non‑editable in this portal.</p>
                )}
              </>
            }

          </Col>
        }
        <Col xs={6} md={7} className="d-flex align-items-center gap-2">
          {/*Final Resolution Letter Checkbox */}
          {(((mapMasters(status, statusData) === STATUS.RESOLVE || mapMasters(status, statusData) === STATUS.CLOSE) &&
            (data?.grievanceStatus?.statusId === STATUS.REOPEN && mapMasters(status, statusData) === STATUS.RESOLVE)) ||
            data?.requestIRDAIForClosure) && (
              <>
                <LabelField
                  name="Final Resolution Letter"
                  required
                  className="w-auto"
                />
                <Input
                  type="checkbox"
                  className="mb-2 border border-dark rounded"
                  checked={getValues('isFRRDocList')}
                  disabled={grievanceDetailsData?.requestIRDAIForClosure}
                  {...register('isFRRDocList', { required: true })}
                  onChange={(e) => {
                    onChangeInput('isFRRDocList', e.target.checked);
                  }}
                />
              </>
            )}
        </Col>
        {errors && (errors['isFRRDocList']?.type === "required") &&
          <p role="alert" className='error-msg mb-1'>*Please check the Final Resolution Letter</p>
        }
      </Row>
    </>
  );
}

export default GrievanceDetails;